/**
 * Tela de falha (R19.4): explicação compreensível derivada de `last_error`, com
 * orientação de próximo passo e **sem expor detalhes internos crus**. Oferece
 * repetição quando fizer sentido e a opção de enviar outro documento.
 */
import { explainFailure } from "../../lib/errors";
import { Button } from "../Button";
import { AlertIcon, RefreshIcon } from "../Icons";

interface FailureScreenProps {
  readonly lastError: string | null;
  readonly onRetry: () => void;
  readonly onStartOver: () => void;
}

export function FailureScreen({ lastError, onRetry, onStartOver }: FailureScreenProps) {
  const explanation = explainFailure(lastError);
  return (
    <section className="mp-card" aria-labelledby="failure-title">
      <div style={{ textAlign: "center" }}>
        <span className="mp-hero-icon mp-hero-icon--error" aria-hidden="true">
          <AlertIcon size={36} />
        </span>
      </div>
      <h1 className="mp-card__title" id="failure-title" style={{ textAlign: "center" }}>
        {explanation.title}
      </h1>
      <p className="mp-card__subtitle" style={{ textAlign: "center" }}>
        {explanation.message}
      </p>

      <div className="mp-alert mp-alert--info" role="status">
        <span className="mp-alert__icon">
          <AlertIcon size={20} />
        </span>
        <div className="mp-alert__body">
          <p className="mp-alert__title">O que fazer agora</p>
          <div className="mp-alert__text">{explanation.nextStep}</div>
        </div>
      </div>

      <div className="mp-actions">
        {explanation.retryable ? (
          <Button variant="primary" onClick={onRetry}>
            <RefreshIcon size={18} /> Tentar novamente
          </Button>
        ) : null}
        <Button variant={explanation.retryable ? "ghost" : "primary"} onClick={onStartOver}>
          Enviar outro documento
        </Button>
      </div>
    </section>
  );
}
